(function () {
    'use strict';

    angular
        .module('elogbooksDirectives')
        .directive('elbAuditTrail', ElogbooksAuditTrail);

    ElogbooksAuditTrail.$inject = [];

    function ElogbooksAuditTrail() {
        return {
            restrict: 'AE',
            scope: {
                eventCollectionResponse: '=?',
                messageCollectionResponse: '=?',
                fileCollectionResponse: '=?',
                taskResponse: '=?',
                templatePath: '@',
                showFeed: '=?',
                isHelpdesk: '=',
                contactsLink: '=',
                eventLink: '=?',
                messageLink: '=?',
                fileLink: '=?',
                entityType: '@?',
                entityLink: '=?',
                eventCollectionTransform: '&?'
            },
            templateUrl: '/modules/directives/elb-audit-trail/audit-trail.html',
            controller: ElogbooksAuditTrailController,
            controllerAs: 'vm'
        };
    }

    ElogbooksAuditTrailController.$inject = ['$scope', 'auditTrailLoader'];

    function ElogbooksAuditTrailController($scope, auditTrailLoader) {
        var vm = this;

        vm.auditTrailState = auditTrailLoader.createState();
        vm.taskResponse = $scope.taskResponse;
        vm.templatePath = $scope.templatePath;
        vm.showFeed = $scope.showFeed;
        vm.isHelpdesk = $scope.isHelpdesk;
        vm.contactsLink = $scope.contactsLink;
        vm.eventCollectionResponse = null;
        vm.messageCollectionResponse = null;
        vm.fileCollectionResponse = null;

        load();

        function load() {
            auditTrailLoader.load({
                entityType: $scope.entityType,
                entityLink: $scope.entityLink,
                state: vm.auditTrailState,
                resources: {
                    events: {
                        response: $scope.eventCollectionResponse,
                        link: $scope.eventLink,
                        transform: transformEventCollection
                    },
                    messages: {
                        response: $scope.messageCollectionResponse,
                        link: $scope.messageLink
                    },
                    files: {
                        response: $scope.fileCollectionResponse,
                        link: $scope.fileLink
                    }
                }
            }).then(function (result) {
                vm.auditTrailState = result.state;
                vm.eventCollectionResponse = result.responses.events;
                vm.messageCollectionResponse = result.responses.messages;
                vm.fileCollectionResponse = result.responses.files;
            });
        }

        function transformEventCollection(eventCollectionResponse) {
            if (!$scope.eventCollectionTransform) {
                return eventCollectionResponse;
            }

            return $scope.eventCollectionTransform({
                response: eventCollectionResponse
            }) || eventCollectionResponse;
        }
    }
})();
